import React from 'react';
import './answer-cards.css';

const SUIT_COLORS = {
  h: '#E5735A', // hearts
  d: '#497CAB', // diamonds
  c: '#49AB78', // clubs — matches clubs-large.svg fill + Call action color
  s: '#424242', // spades
};

const SUIT_NAMES = {
  h: 'hearts',
  d: 'diamonds',
  c: 'clubs',
  s: 'spades',
};

const getCardText = (value) => {
  const map = { t: '10', j: 'J', q: 'Q', k: 'K', a: 'A' };
  return map[value.toLowerCase()] || value.toUpperCase();
};

const AnswerCard = ({ card, isTop }) => {
  const value = card[0];
  const suit = card[1].toLowerCase();
  const text = getCardText(value);
  const color = SUIT_COLORS[suit] || '#424242';
  const suitName = SUIT_NAMES[suit] || 'spades';

  return (
    <div className={`answer-card-wrapper${isTop ? ' answer-card-wrapper--top' : ''}`}>
      <div className="answer-card-frame">
        <img
          src={`/svgs/${suitName}-large.svg`}
          alt={suitName}
          className="answer-card-suit"
        />
        <div className="answer-card-text" style={{ color }}>
          {text}
        </div>
      </div>
    </div>
  );
};

const AnswerCards = ({ selectedHand }) => {
  if (!selectedHand?.card1 || !selectedHand?.card2) return null;

  return (
    <div className="answer-cards-container">
      <AnswerCard card={selectedHand.card1} isTop={false} />
      <AnswerCard card={selectedHand.card2} isTop={true} />
    </div>
  );
};

export default AnswerCards;
